<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres :titulo="tituloUsuarios" :botoes="botoesHeader" breakpoint="xl" />
      </template>
      <b-card-body>
        <b-col lg="6" class="filtro-pesquisa">
          <b-form-group label="Busca:" label-for="filter-input" label-cols-sm="3" label-align-sm="right" label-size="sm"
            class="mb-3">
            <b-input-group size="sm">
              <b-form-input id="filter-input" v-model="filter" type="search" class="search-input"
                placeholder="Escreva para Pesquisar"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table id="usuariosDaUgTable" :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage"
          :filter="filter" hover no-border-collapse sort-by="" :sort-desc="true" striped stacked="xl" show-empty
          per-page="10" @filtered="onFiltered">
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-md-none" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item @click="alertaRemove(row.item)">
                <font-awesome-icon icon="trash" />
                <span>Remover Perfis</span>
              </b-dropdown-item>
              <b-dropdown-item @click="editarUsuario(row.item)">
                <font-awesome-icon icon="edit" />
                <span>Editar</span>
              </b-dropdown-item>
            </b-dropdown>
            <div class="actions-icons lgvert d-none d-md-flex justify-content-center">
              <b-link class="text-dark" @click="alertaRemove(row.item)">
                <font-awesome-icon icon="ban" />
                <div style="font-size: 12px">Remover Perfis</div>
              </b-link>
              <b-link class="text-dark" @click="editarUsuario(row.item)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
            </div>
          </template>
        </b-table>
        <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="10"
          aria-controls="usuariosDaUgTable"></b-pagination>
      </b-card-body>
    </b-card>

    <b-modal id="modal-buscar-usuario" title="Buscar usuário" centered hide-footer size="xl">

      <b-card class="m-3" no-body>
        <b-card>
          <b-container>
            <b-row>
              <b-col cols="12" class="d-flex column align-items-center justify-content-center my-3">
                <b-form-group id="input-group-busca" label="Busque por um usuário no sistema"
                  label-for="input-busca-usuarios">
                  <InputBuscaUsuario id="input-busca-usuarios" class="w-100" v-model="usuarioS" />
                </b-form-group>
              </b-col>

            </b-row>
            <b-row style="text-align: center">
              <b-col cols="12" lg="4">
                <b-form-group v-if="usuarioS">
                  <span style="font-weight: bold">Nome:</span>
                  <span style="margin-left: 5px">{{ usuarioS?.Nome }}</span>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">

                <b-form-group v-if="usuarioS">
                  <span style="font-weight: bold">CPF:</span>
                  <span style="margin-left: 5px">{{ usuarioS?.Cpf }}</span>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group>
                  <span style="font-weight: bold">Unidade Gestora:</span>
                  <span style="margin-left: 5px">{{ ug?.Nome }}</span>
                </b-form-group>
              </b-col>
            </b-row>
          </b-container>

          <b-card-group deck>
            <b-card header="Permissões a serem adicionadas">
              <SeletorDePerfis :perfisSelecionados="perfisSelecionados" :cin="true" :perfisUsuarioUG="perfisUsuarioUG"
                @AdicionandoPerfil="addPerfilLista" @removendoPerfil="removerPerfilLista"
                @removerPerfis="removerPerfisLista" />

              <div class="d-flex flex-column align-items-center mt-1">
                <b-button variant="success" size="sm" class="d-block mb-2" :disabled="perfisSelecionados.length === 0"
                  @click="addPermissoes">Adicionar permissões</b-button>
              </div>
            </b-card>
            <b-card header="Permissões do usuário">
              <b-overlay :show="overlayTabela">
                <b-table striped hover stacked="md" :items="perfisUsuarioUG" :fields="computedFields">
                  <template slot="cell(actions)" slot-scope="perfilData">
                    <b-button size="sm" @click="alertaPermissaoRemove(perfilData.item)">
                      <font-awesome-icon icon="trash" />
                    </b-button>
                  </template>
                </b-table>
              </b-overlay>
            </b-card>
          </b-card-group>
        </b-card>
      </b-card>
    </b-modal>
  </div>
</template>

<script lang="ts">
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import usuarioService from "@/services/administracao/usuarioService";
import ugService from "@/services/administracao/ugService";
import { store } from "@/store";
import { fieldsConsultaUsuariosPorUg } from '@/types/administracao/usuarios/fields-usuarios';
import { BotaoSagres } from '@/types/botao-sagres';
import { TableField } from '@/types/table-field';
import { UtilsTS } from '@/utilsts';
import { Perfil } from '@/types/administracao/cadastro-permissoes/perfil';
import { mixins } from 'vue-class-component';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import { UsuarioResumido } from '@/types/administracao/usuarios/usuario-resumido';
import { Usuario } from '@/types/administracao/usuarios/usuario';
import { EnvioUsuarioPermissoes } from "@/types/administracao/usuarios/envio-usuario-permissoes";
import SeletorDePerfis from "@/components/administracao/usuarios/SeletorDePerfis.vue";
import InputBuscaUsuario from '@/components/shared/InputBuscaUsuario.vue';
import { UsuarioSumario } from '@/types/usuario-sumario';
const CompProps = Vue.extend({
  name: 'UsuariosPorUG',
  components: { HeaderSagres, SeletorDePerfis, InputBuscaUsuario, }
})


interface perfilUG {
  ID_USUARIO_PERFIL: number;
  DESCRICAO: string;
  ID: number;
}

@Component
export default class UsuariosPorUG extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'plus',
      texto: 'Novo Usuário',
      acao: () => { this.$bvModal.show('modal-buscar-usuario') }
    },
  ]

  fields: TableField[] = fieldsConsultaUsuariosPorUg
  items: UsuarioResumido[] = []
  ug: UnidadeGestoraResumida | null = null
  filter = ''
  currentPage = 1
  pageSize = 10
  totalRows = 0
  tableBusy = false


  //Modal ----------------------------------

  usuarioS = new UsuarioSumario()
  perfisSelecionados: Perfil[] = [];
  perfisUsuarioUG: perfilUG[] = [];
  envioPermissoes: EnvioUsuarioPermissoes[] = [];
  overlayTabela = false
  // titulo do card
  get computedFields() {
    const fields = [{ key: "DESCRICAO", label: "Perfis" }];
    if (this.perfisUsuarioUG.length > 0) {
      fields.push({ key: "actions", label: "" });
    }
    return fields;
  }

  user: Usuario | undefined = undefined;

  async created() {
    try {
      store.blockScreen = true
      this.ug = await this.carregarUG()
      await this.loadData()
    } catch (e) {
      console.error(e)
    } finally {
      store.blockScreen = false
    }
  }

  get tituloUsuarios(): string {
    return `Usuários do(a) ${this.ug?.Nome}`
  }

  async loadData(): Promise<any> {
    try {
      this.tableBusy = true
      const response: UsuarioResumido[] = await usuarioService.usuariosDaUg()
      if (!response) return this.$toast.error("Erro ao obter a lista de usuários");
      this.items = response;
      this.totalRows = response.length
    } catch (e: any) {
      this.tratarError(e)
      this.items = []
      this.totalRows = 0
    } finally {
      this.tableBusy = false;
    }
  }

  alertaRemove(usuario: Usuario): any {
    this.$bvModal.msgBoxConfirm(`Deseja remover perfil(is) de ${this.capitalize(usuario.NOME)} ?`, {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Confirmar',
      title: 'Remover Perfil',
    }).then(value => {
      if (value) this.removerPerfis(usuario)
    }).catch(err => {
      console.error(`Erro ao operar o dialog de alerta de remoção de perfil`, err)
    })
  }

  async removerPerfis(usuario: Usuario): Promise<void> {
    try {
      let response = false
      if (usuario.ID_USUARIO) {
        const idUsuario = usuario.ID_USUARIO.toString()
        //response = await usuarioService.removePerfil(idUsuario)
        response = await usuarioService.removerPermissaoUsuario(idUsuario, String(this.ug?.idCRP))
        if (response) {
          this.$toast.success(`Perfil removido com sucesso!`)
          await this.loadData()
          this.$emit('refresh')
        } else if (usuario.NOME) {
          this.$toast.error(`Houve uma falha ao remover o(s) perfil(is) de ${this.capitalize(usuario.NOME)}.\nFavor atualizar a página e tentar novamente.`)
        }
      } else {
        this.$toast.error('Houve uma falha ao ler os dados deste usuário.\nFavor atualizar a página e tentar novamente.')
      }
    } catch (e: any) {
      this.tratarError(e)
    }
  }

  async carregarUG(): Promise<UnidadeGestoraResumida | null> {
    try {
      return await ugService.buscarUG()
    } catch (e) {
      console.error(e)
      return null
    }
  }

  editarUsuario(usuario) {
    if (usuario) {
      try {
        return this.$router.push({
          name: `seguranca-administracao--editar-usuarios-ug`,
          params: { usuario: usuario }
        });
      } catch (e: any) {
        console.error(e)
        this.tratarError(e)
        return null
      }
    }
    return this.$toast.error(`Erro ao obter dados de Usuario`);
  }

  onFiltered(filteredItems: any): any {
    this.totalRows = filteredItems.length
    this.currentPage = 1
  }

  //Funções para o modal-----------------------------------


  //Atualiza a lista com os dados do emit
  addPerfilLista(listaAtualizada: Perfil[]) {
    this.perfisSelecionados = [];
    this.perfisSelecionados = listaAtualizada;
  }
  //Atualiza a lista com os dados do emit
  removerPerfilLista(listaAtualizada: Perfil[]) {
    this.perfisSelecionados = [];
    this.perfisSelecionados = listaAtualizada;
  }
  //Limpa a lista a partir do sinal do emit
  removerPerfisLista() {
    this.perfisSelecionados = [];
  }

  // Requisição para adicionar as permissões selecionados ao Usuario
  async addPermissoes() {
    this.perfisSelecionados.forEach((perfil) => {
      const idUsuario = Number(this.usuarioS?.IdUsuario);
      const idUnidadeGestora = Number(this.ug?.idCRP)
      const idPerfil = perfil.Id;
      //console.log(idUnidadeGestora)
      if (!idUnidadeGestora) return this.$toast.error("Id da ug não recebido");

      const novoObjetoPermissaoEnviar: EnvioUsuarioPermissoes = {
        idUsuario,
        idUnidadeGestora,
        idPerfil,
      };
      this.envioPermissoes.push(novoObjetoPermissaoEnviar);
    });

    try {
      store.blockScreen = true;
      const response = await usuarioService.adicionarPermissaoUsuario(
        this.envioPermissoes
      );
      if (this.perfisSelecionados.length === 1)
        this.$toast.success("Permissão adicionada com sucesso!");
      else this.$toast.success("Permissões adicionadas com sucesso!");
      //console.log(response)
      this.atualizarCompAdd(response);
      await this.loadData()
    } catch (e: any) {
      this.tratarError(e);
      this.$toast.error("Erro ao adicionar a permissão");
    } finally {
      //retira tela de carregamento
      store.blockScreen = false;
      //zerando as listas utilizadas
      this.perfisSelecionados = [];
      this.envioPermissoes = [];
      //Chama emit
    }
  }

  //Atualiza a lista de permissões após uma permissão ser adicionada
  atualizarCompAdd(novasPerms) {
    //console.log(novasPerms)
    novasPerms.forEach((elemento) => {
      const ID_USUARIO_PERFIL = elemento.idUsuarioPerfil;
      const DESCRICAO = elemento.perfil.Descricao;
      const ID = elemento.perfil.Id;

      const objetoAtualizado: perfilUG = {
        ID_USUARIO_PERFIL,
        DESCRICAO,
        ID,
      };
      this.perfisUsuarioUG.push(objetoAtualizado);
    });
  }

  async removerItemPerfilUsuario(id: number) {
    //console.log(id)
    try {
      store.blockScreen = true;
      const response = await usuarioService.removerPerfilPermissao(id);
      this.$toast.success("Permissão removida com sucesso!");
      this.removerCompAdd(id);
    } catch (e: any) {
      console.error(e);
      this.$toast.error("Erro ao remover permissão");
    } finally {
      store.blockScreen = false;
    }
  }

  //Confirmação para exxcluir um perfil
  alertaPermissaoRemove(perfil: perfilUG): any {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja remover a permissão de ${this.capitalize(perfil.DESCRICAO)} ?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: "Remover Permissão",
        }
      )
      .then((value) => {
        if (value) this.removerItemPerfilUsuario(perfil.ID_USUARIO_PERFIL);
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta de remoção de perfil`,
          err
        );
      });
  }

  removerCompAdd(idRemover: number) {
    this.perfisUsuarioUG = this.perfisUsuarioUG.filter(
      (elemento) => elemento.ID_USUARIO_PERFIL !== idRemover
    );
    /**for(let p = 0; p<this.perfisUsuarioUG.length; p++){
        if(this.perfisUsuarioUG[p].ID_USUARIO_PERFIL === idRemover){
          this.perfisUsuarioUG.splice(p, 1)
          p--;
        }
      }**/
  }

  //atualiza lista de perfis já adicionadas ao usuario
  async verificaUsuario() {
    if (this.usuarioS) {
      this.perfisUsuarioUG = []
      this.items.forEach((userUG) => {
        if (userUG.ID_USUARIO === this.usuarioS.IdUsuario) {
          this.$toast.warning("Este usuário já existe nessa UG")
          this.editarUsuario(userUG)
        }
      })
    }

  }

  @Watch('usuarioS')
  onUserChange() {
    this.verificaUsuario()
  }

};
</script>

<style scoped>
.search-input {
  max-width: 300px;
  border-radius: 50px;
  padding: 10px 20px;
  border: 1px solid #ced4da;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #66afe9;
  outline: none;
  box-shadow: 0 0 8px rgba(102, 175, 233, 0.6);
}
</style>